import React from "react";
import { ArrowRight, ArrowLeft, Sparkles } from "lucide-react";
import Manat from "../components/Manat";

const CREDIT_LIMIT = 4000;

export default function CreditOffer({ go, user, onContinue }) {
  const fullName = `${user?.firstName || ""} ${user?.lastName || ""}`.trim() || "Müştəri";

  return (
    <section className="screen co-screen" data-testid="credit-offer-screen">
      <button
        className="co-back"
        onClick={() => go("home")}
        data-testid="co-back-btn"
        aria-label="Geri"
      >
        <ArrowLeft size={20} strokeWidth={2.6} />
      </button>

      <div className="co-content">
        <div className="co-logo-wrap">
          <div className="co-logo-ring" />
          <div className="co-logo-halo" />
          <div className="co-logo-inner">
            <img src="/assets/logo.png" alt="PULPAY" />
          </div>
        </div>

        <div className="co-badge">
          <Sparkles size={13} strokeWidth={2.8} />
          <span>Təsdiq alındı</span>
        </div>

        <h1 className="co-title" data-testid="co-title">
          Hörmətli <b>{fullName}</b>
        </h1>

        <p className="co-body" data-testid="co-body">
          Sizə <b>{CREDIT_LIMIT.toLocaleString("az-AZ")} <Manat size={16} /> </b>
          dək kredit limiti uyğun görüldü. İstədiyiniz məbləği seçim edə bilərsiniz.
        </p>

        <div className="co-limit">
          <span className="co-limit-label">Təsdiqlənmiş limit</span>
          <div className="co-limit-amount">
            {CREDIT_LIMIT.toLocaleString("az-AZ")} <em><Manat size={22} /></em>
          </div>
        </div>

        <button
          type="button"
          className="co-cta"
          onClick={onContinue}
          data-testid="co-continue-btn"
        >
          <span>Davam et</span>
          <ArrowRight size={18} strokeWidth={2.8} />
        </button>
      </div>
    </section>
  );
}
